<p>adhoc-booking-detail works!</p>
